export const DEFAULT_TAX_LANGUAGE_KEY = 'en';
//# sourceMappingURL=constants.js.map